export default __webpack_public_path__ + "static/media/Infographic-thumbnail.bc35feb0.jpg";